import React from 'react';

import Concerts from 'components/Concerts';
import { EntityContext } from 'context/entityContext';

import Message from 'components/base/Message/Message';
import Layout from 'components/styled/Layout/Layout';

const ConcertsPage: React.FC = () => {
  const ctx = React.useContext(EntityContext);
  const { compareMode } = ctx;
  const isCompare = Boolean(compareMode);

  if (isCompare) {
    return (
      <Layout.MaxWidth>
        <Message>
          Unfortunately there are no components available in compare mode on
          this topic for artists
        </Message>
      </Layout.MaxWidth>
    );
  }

  return (
    <>
      <Concerts dateStatus="upcoming" />

      <Concerts dateStatus="past" />
    </>
  );
};

export default ConcertsPage;
